export default [
  {
    path: '',
    component: () => import('@/admin/pages/home/Index'),
    name: 'admin.home',
  },
];
